import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async savePeriodoAnaliseOrcamentaria({ commit }, data) {
      try {
        return await api.post('/analises-orcamentarias/periodos', data)
      } catch (error) {
        throw error
      }
    },

    async getPeriodosAnaliseOrcamentaria({ commit }) {
      try {
        const response = await api.get('/analises-orcamentarias/periodos')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getPeriodoAnaliseOrcamentaria({ commit }, periodoId) {
      try {
        const response = await api.get(
          `/analises-orcamentarias/periodos/${periodoId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updatePeriodoAnaliseOrcamentaria({ commit }, data) {
      try {
        return await api.put(
          `/analises-orcamentarias/periodos/${data.id}`,
          data,
        )
      } catch (error) {
        throw error
      }
    },

    async activePeriodoAnaliseOrcamentaria({ commit }, periodoId) {
      try {
        return await api.put(
          `/analises-orcamentarias/periodos/${periodoId}/active`,
        )
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
